import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Tours & Packages', path: '/tours' },
    { name: 'Contact', path: '#contact' },
    { name: 'Privacy Policy', path: '#privacy' },
    { name: 'Terms & Conditions', path: '#terms' },
  ];

  const popularTours = [
    { name: 'European Adventure', image: 'https://public.readdy.ai/ai/img_res/454f021a6bb77a8b6c45c4595fce2c3d.jpg' },
    { name: 'Asian Discovery', image: 'https://readdy.ai/api/search-image?query=stunning%20asian%20temples%20with%20golden%20details%20surrounded%20by%20lush%20tropical%20gardens%20and%20peaceful%20atmosphere%20travel%20photography&width=80&height=80&seq=ft2&orientation=squarish' },
    { name: 'Caribbean Paradise', image: 'https://readdy.ai/api/search-image?query=pristine%20caribbean%20beach%20with%20turquoise%20water%20white%20sand%20and%20palm%20trees%20under%20sunny%20sky%20tropical%20paradise%20travel%20photography&width=80&height=80&seq=ft3&orientation=squarish' },
  ];

  return (
    <footer className="bg-navy-900 text-white">
      {/* Upper Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/9396f31d77c954f423ce345f87cd25c5/87c3864ad4b2a7213a20510bc18b6a66.png" 
                alt="Candy World Tours" 
                className="h-10 w-auto"
              />
              <span className="text-lg font-bold">Candy World Tours</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6 max-w-xs">
              Creating unforgettable travel experiences with care, adventure, and a touch of sweetness since 2010.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-accent-pink hover:border-accent-pink transition-all cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-accent-pink hover:border-accent-pink transition-all cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-accent-pink hover:border-accent-pink transition-all cursor-pointer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-accent-pink hover:border-accent-pink transition-all cursor-pointer">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold uppercase tracking-wide mb-6">Quick Links</h3>
            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-gray-400 hover:text-accent-pink transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Tours */}
          <div>
            <h3 className="text-base font-bold uppercase tracking-wide mb-6">Popular Tours</h3>
            <ul className="space-y-5">
              {popularTours.map((tour, index) => (
                <li key={index}>
                  <Link to="/tours" className="flex items-center gap-3 group cursor-pointer">
                    <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0">
                      <img src={tour.image} alt={tour.name} className="w-full h-full object-cover" />
                    </div>
                    <span className="text-sm text-gray-400 group-hover:text-accent-pink transition-colors">
                      {tour.name}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base font-bold uppercase tracking-wide mb-6">Get in Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-accent-pink mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">+44 7445 660213</p>
                  <p className="text-xs text-gray-500">Mon-Fri 9am-6pm</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-accent-pink mt-1"></i>
                <p className="text-sm text-gray-400">candyworldtours@gmail.com</p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-accent-pink mt-1"></i>
                <p className="text-sm text-gray-400">London<br />United Kingdom</p>
              </li>
            </ul>
            <a
              href="https://wa.me/+447445660213"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 w-full h-12 bg-green-500 hover:bg-green-600 text-white rounded-lg flex items-center justify-center gap-2 font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-white/10 relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-[120px] font-bold text-[#FAF8F5]/5 tracking-tighter select-none" style={{ letterSpacing: '-2px' }}>
            CANDY WORLD TOURS
          </span>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Candy World Tours. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-gray-400 hover:text-accent-pink transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}